import React, { FC } from 'react'

import { graphql } from 'gatsby'

import Homepage from '..'
import PageHead from '../../components/PageHead'
import withApp from '../../components/withApp/withApp'

const FriendPage: FC = (props) => <Homepage {...props} />

export default withApp(FriendPage)

export const Head = ({ location }: { location: { pathname: string } }) => (
  <PageHead
    title={'Simple, honest mobile'}
    canonical={'https://smarty.co.uk'}
    location={location}
  >
    <meta name="robots" content="noindex" />
  </PageHead>
)

export const query = graphql`
  query {
    contentfulPageSection(sectionName: { eq: "default-faq-list" }) {
      ...FaqSection
    }
  }
`
